const STORAGE_KEY = 'bx_admin_auth_v1';

/** Project code of the platform tenant; only its members may administer projects. */
export const PLATFORM_PROJECT_CODE = (
  process.env.REACT_APP_PLATFORM_PROJECT_CODE || 'batamx'
).toLowerCase();

export type RoleAccess = {
  project?: boolean;
  dashboard?: boolean;
  ecommerce?: boolean;
  user?: boolean;
  customer?: boolean;
  notification?: boolean;
  custom?: boolean;
  booking?: boolean;
  reward?: boolean;
  [key: string]: boolean | undefined;
};

export type StoredAuth = {
  token: string;
  /**
   * Set once platform staff switch into another project. The token keeps carrying
   * `impersonatedBy`, so the session may still hop between projects.
   */
  impersonating?: boolean;
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
    projectId?: string;
    projectCode?: string;
    roleAccess?: RoleAccess;
  };
};

export function readAuth(): StoredAuth | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as StoredAuth) : null;
  } catch {
    return null;
  }
}

export function writeAuth(payload: StoredAuth) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function clearAuth() {
  localStorage.removeItem(STORAGE_KEY);
}


